var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#organization-icon-active_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.65 13.65v11.7h5.85v-11.7H5.65ZM5.325 13a.325.325 0 0 0-.325.325V26h6.825c.18 0 .325-.145.325-.325v-12.35a.325.325 0 0 0-.325-.325h-6.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.65 13.65v11.7h5.85v-11.7h-5.85Zm-.325-.65a.325.325 0 0 0-.325.325V26h6.825c.18 0 .325-.145.325-.325v-12.35a.325.325 0 0 0-.325-.325h-6.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#152F4D",
    d: "M8.53 10h7.15v13H8.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.18 10.65v11.7h5.85v-11.7H9.18ZM8.855 10a.325.325 0 0 0-.325.325V23h6.825c.18 0 .325-.145.325-.325v-12.35a.325.325 0 0 0-.325-.325h-6.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00F2B6",
    fillRule: "evenodd",
    d: "M10.805 11.95a.325.325 0 0 0-.325.324v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Zm1.3 0a.325.325 0 0 0-.325.324v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Zm1.3 0a.325.325 0 0 0-.325.324v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Zm-2.6 2.6a.325.325 0 0 0-.325.326v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Zm1.3 0a.325.325 0 0 0-.325.326v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Zm1.3 0a.325.325 0 0 0-.325.326v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Z",
    clipRule: "evenodd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 2.5,
    y: 3.5,
    stroke: "#fff",
    rx: 9.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "organization-icon-active_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    y: 3,
    fill: "#fff",
    rx: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationIconActive);
export default __webpack_public_path__ + "static/media/organization-icon-active.58a9fbfaa0d5455c4621ab4c64d1eb1f.svg";
export { ForwardRef as ReactComponent };